/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbUserCentresLiesGridDto } from './FcbUserCentresLiesGridDto';
import {
    FcbUserCentresLiesGridDtoFromJSON,
    FcbUserCentresLiesGridDtoFromJSONTyped,
    FcbUserCentresLiesGridDtoToJSON,
} from './FcbUserCentresLiesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbUserCentresLiesGridDtoPaginatedResults
 */
export interface FcbUserCentresLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbUserCentresLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbUserCentresLiesGridDto>}
     * @memberof FcbUserCentresLiesGridDtoPaginatedResults
     */
    results?: Array<FcbUserCentresLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbUserCentresLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbUserCentresLiesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbUserCentresLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUserCentresLiesGridDtoPaginatedResultsFromJSON(json: any): FcbUserCentresLiesGridDtoPaginatedResults {
    return FcbUserCentresLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbUserCentresLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUserCentresLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbUserCentresLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbUserCentresLiesGridDtoPaginatedResultsToJSON(value?: FcbUserCentresLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbUserCentresLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

